
export const CONFIRM_MODAL_DESCRIPTION = `Deleting this bot may cause you to lose important history.
                                          We recommend disconnecting the bot from any pages instead.
                                          Please note, this action is final and cannot be undone.`;
export const CONFIRM_MODAL_INSTRUCTION = "To proceed, please type the word 'DELETE' below:";
